import axios from "../../services/api";

let default_root = '/bwapi/';
let root = default_root + 'suppliers';
// let config_name = 'supplier';

export default {
    search(query, callback, failure_callback) {
        axios.get(root + "/search?search=" + encodeURIComponent(query))
            .then((response) => {
                callback(response.data);
            })
            .catch((response) => {
                failure_callback(response.response);
            });
    },
    searchOnlySuppliers(query, callback, failure_callback) {
        axios.get(root + "/search?only_suppliers&search=" + encodeURIComponent(query))
            .then((response) => {
                callback(response.data);
            })
            .catch((response) => {
                failure_callback(response.response);
            });
    },
    searchOnlyPunchout(query, callback, failure_callback) {
        axios.get(root + "/search?only_punchout&search=" + encodeURIComponent(query))
            .then((response) => {
                callback(response.data);
            })
            .catch((response) => {
                failure_callback(response.response);
            });
    },
    getHeader(item_id, callback) {
        axios.get(root + "/" + item_id + "/header")
            .then((response) => {
                callback(response.data);
            });
    },
    getCharts(item_id, callback) {
        axios.get(root + "/" + item_id + "/charts")
            .then((response) => {
                callback(response.data);
            });
    },
    getChartAdditionalRating(item_id, callback) {
        return axios.get(root + "/" + item_id + "/charts/additional_rating")
            .then((response) => {
                callback(response.data);
            });
    },
    saveAdditionalRating(item_id, form) {
        return axios.post(root + "/" + item_id + "/charts/additional_rating", form)
    },
    getChartAnnualRating(item_id, callback) {
        axios.get(root + "/" + item_id + "/charts/annual_rating")
            .then((response) => {
                callback(response.data);
            });
    },
    getChartCertification(item_id, callback) {
        return axios.get(root + "/" + item_id + "/charts/certification")
            .then((response) => {
                callback(response.data);
            });
    },
    getChartPerformance(item_id, callback) {
        axios.get(root + "/" + item_id + "/charts/performance")
            .then((response) => {
                callback(response.data);
            });
    },
    getChartSecurity(item_id, callback) {
        return axios.get(root + "/" + item_id + "/charts/security")
            .then((response) => {
                callback(response.data);
            });
    },
    saveSecurity(item_id, form) {
        return axios.post(root + "/" + item_id + "/charts/security", form)
    },
    getChartsTurnover(item_id, callback) {
        return axios.get(root + "/" + item_id + "/charts/turnover")
            .then((response) => {
                callback(response.data);
            });
    },
    saveTurnover(item_id, form) {
        return axios.post(root + "/" + item_id + "/charts/turnover", form)
    },
}